import { ColDef } from 'ag-grid-community';
import {
  createDateHasAllTimeCol,
  createIdCol,
  createTypoCol,
} from '@/src/helpers/agColumnHelper';

export const recyclingProductOptionColumn = (): ColDef[] => [
  createIdCol(),
  createTypoCol({
    field: 'size',
    headerName: '옵션 명',
  }),
  createTypoCol({
    field: 'weight',
    valueFormatter: params => {
      return `${params.value}`;
    },
    headerName: '무게 (g)',
  }),
  createTypoCol({
    field: 'carbonEmissionReduction',
    valueFormatter: params => {
      return `${params.value}`;
    },
    headerName: '탄소 감축량 (g)',
  }),
  createTypoCol({
    field: 'pineScore',
    valueFormatter: params => params.value?.toString(),
    headerName: '소나무 지수',
  }),
  createDateHasAllTimeCol({
    field: 'createdAt',
    headerName: '등록 일시',
  }),
];
